import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'self... Remove this comment to see the full error message
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Get the self-service-api key for a given apiName
 * @param {*} apiName
 * @returns the i18n key for the apiName
 */

export const getI18nKeyForApiName = apiName => `pricing-pages.products.${apiName}.title`;
/**
 * Display the product name for an apiName or upgrade product
 */
const ProductName = props => {
  let {
    apiName
  } = props;
  const {
    upgradeProduct
  } = props;
  if (props.upgradeProduct) {
    apiName = UpgradeProductToApiNameMap[upgradeProduct];
  }
  const i18nKey = getI18nKeyForApiName(apiName);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey
  });
};
ProductName.propTypes = {
  upgradeProduct: PropTypes.string,
  apiName: PropTypes.string
};
export default ProductName;